import { Card } from "@/components/ui/Card";
import type { DonationSummaryProps } from "./DonationSummaryProps";
import { DonationSummaryContent } from "./DonationSummaryContent";
import { Collapsible, type CollapsibleRef } from "@/components/ui/Collapsible";
import { useNavigate } from "@/hooks/useNavigate";
import { useEffect, useRef } from "react";
import { clsx } from "clsx";
import classes from "./DonationSummary.module.scss";

export function DonationSummary(props: DonationSummaryProps) {
  const { className, collapsible, ...donationSummaryContentProps } = props;
  const { isFinalStep } = useNavigate();
  const collapsibleRef = useRef<CollapsibleRef>(null);
  const hasBeenOpened = useRef(false);

  useEffect(() => {
    if (hasBeenOpened.current) return;

    if (isFinalStep) {
      collapsibleRef.current?.open();
      hasBeenOpened.current = true;
    }
  }, [isFinalStep]);

  return (
    <Card className={clsx(classes.hyphens, className)}>
      {collapsible ? (
        <Collapsible ref={collapsibleRef}>
          <DonationSummaryContent {...donationSummaryContentProps} />
        </Collapsible>
      ) : (
        <DonationSummaryContent {...donationSummaryContentProps} />
      )}
    </Card>
  );
}
